// @flow
import { compose } from 'recompose';
import styled, { css } from 'styled-components';
import { withTextIcon } from './withText';
import { withCircle } from './withCircle';
import { withSvg } from './withSvg';
import { withAnimate } from './withAnimate';
import { withRect } from './withRect';

export const Path = styled.path`
  pointer-events: none;
`;

export const PathIcon = styled(Path)`
  ${({ outline }) =>
    outline === true
      ? css`
          stroke: var(--color-black);
        `
      : css`
          fill: var(--color-white);
        `};
  ${({ fill }) => {
    const style = fill ? `fill: var(--color-${fill});` : 'stroke: none';
    return css`
      ${style};
    `;
  }};
`;

export const ShapeIcon = styled(Path)`
  ${({ outline }) =>
    outline === true
      ? css`
          stroke: var(--color-grey-4);
          fill: none;
        `
      : css`
          fill: var(--color-white);
        `};
`;

export const RoundIconWithText = compose(
  withTextIcon,
  withCircle,
  withSvg,
)(PathIcon);

export const TextIcon = withTextIcon(PathIcon);

export const RoundIcon = compose(
  withCircle,
  withSvg,
)(PathIcon);

export const enhanceAnimatedSVGRect = compose(
  withRect,
  withSvg,
  withAnimate,
);

export const PlainIcon = compose(withSvg)(PathIcon);

export const GPath = styled.g`
  fill: ${({ fill = 'none' }) =>
    fill === 'none' ? 'none' : `var(--color-${fill})`};
  stroke: ${({ stroke = 'black' }) => `var(--color-${stroke})`};
`;
